import React, { useState } from 'react';
import './App.css';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import NotFound from './pages/NotFound';
import ExtraInfoPage from './pages/ExtraInfoPage';
import ContactPage from './pages/ContactPage';
import GalleryCategoriesPage from './pages/GalleryCategoriesPage';

function App() {
  const [language, setLanguage] = useState('en');
  return (
    <Router>
      <div className="App">
        <Navigation language={language} onLanguageChange={setLanguage} />
        <main style={{height: '100vh', minHeight: 0, background: 'none', margin: 0, padding: 0}}>
          <Routes>
            <Route path="/" element={<HomePage language={language} />} />
            <Route path="/gallery" element={<GalleryPage language={language} />} />
            <Route path="/gallery-categories" element={<GalleryCategoriesPage language={language} />} />
            <Route path="/extra-info" element={<ExtraInfoPage language={language} />} />
            <Route path="/contact" element={<ContactPage language={language} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
